import type { Scope } from './types';

export const scopeLabel: Record<Scope, string> = { all: 'Wszystko', own: 'Tylko własne' };

export function fieldKey(resource: string, name: string): string {
  return `${resource}\u0000${name}`;
}

/** Sensitive fields are hidden until someone is allowed to see them, so they start unchecked. */
export function defaultFieldVisible(sensitive: boolean): boolean {
  return !sensitive;
}

export function SensitiveBadge() {
  return (
    <span className="chip sensitive" title="Pole wrażliwe: domyślnie ukryte dla wszystkich poza właścicielem">
      <svg width="11" height="11" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M4 7V5a4 4 0 1 1 8 0v2h1v8H3V7h1Zm2 0h4V5a2 2 0 1 0-4 0v2Z" fill="currentColor" />
      </svg>
      Wrażliwe
    </span>
  );
}
